export default class PressDetailsContent {
	static init() {
		let sidebarWrapper = document.querySelectorAll('.sidebar__wrapper');
		if (!sidebarWrapper) return;
		Array.prototype.forEach.call(sidebarWrapper, el => {
			new PressDetailsContent(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
		let sibling = this.element.parentNode.previousSibling;
		if(!sibling) return;
		let subtitle = sibling.querySelector('.page-heading__suptitle');
		let title = sibling.querySelector('h1');
		if (!title) return;
		let content = this.element.querySelector('.content');
		if (!content) return;
		subtitle.style.maxWidth = content.getBoundingClientRect().width + 'px';
		title.style.maxWidth = content.getBoundingClientRect().width + 'px';

		window.addEventListener('resize', () => {
			subtitle.style.maxWidth = content.getBoundingClientRect().width + 'px';
			title.style.maxWidth = content.getBoundingClientRect().width + 'px';
		});
	}
}
